import { z } from 'zod';

import { BasePType } from './base';

// Test PType for use in various test cases
export const Test = BasePType.extend({
  type: z.enum(['test']),
});

export type Test = z.infer<typeof Test>;
